import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { DeploymentCheckService } from './services/deployment-check.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private destroyRef = inject(DestroyRef);
  deploymentInProgress: boolean = false;
  maintenanceMessage: any;
  constructor(private router: Router, private deploymentCheckService: DeploymentCheckService,
    private translateService: TranslateService) {}

  ngOnDestroy(): void {
    this.deploymentCheckService.stopPolling();
  }

  ngOnInit() {
    this.ensureHttpsConnection();
    const currentUrl = window.location.href;

    if (currentUrl.endsWith('/#') || currentUrl.endsWith('/#/')) {
      this.router.navigateByUrl('/not-found');
    }
    this.deploymentCheckService.startPolling();
    this.deploymentCheckService.currentMessage.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((message) => {
      if (message?.downtime) {
        if (message?.type?.toLowerCase() === 'maintenance page') {
          this.router.navigate(['/maintenance']);
        } else if (message?.type?.toLowerCase() === 'ribbon') {
          this.deploymentInProgress = true;
          this.maintenanceMessage = message?.message;
        }
      } else {
        this.deploymentInProgress = false;
        this.maintenanceMessage = '';
      }
    });
  }

  private ensureHttpsConnection(): void {
      if (environment.enforceHttps && location.protocol !== 'https:') {
        const currentUrl = new URL(window.location.href);
        if (currentUrl.protocol === 'http:') {
          currentUrl.protocol = 'https:';
          location.href = currentUrl.href;
        }
      }
    }
  title = 'global-customer-ui'; // You can set a title or any other properties you want to use in your component

  // You can define any additional logic or methods here if needed
}
